export default __webpack_public_path__ + "static/media/prematuro_extremo.8107c4d6.pdf";